<script>
    export default {
        ///
        //権限関連
        ///

        /**
         * 管理者
         */
        administrator:'0',

        /**
         * 送信者
         */
        sender:'1',

        /**
         * 送信者（通常）
         */
        normalSender:'2',

        /**
         * 一般
         */
        general:'3',


    }
</script>